<template>
  <div class="course">
    <headers></headers>
    <router-view />
    <footers></footers>
  </div>
</template>

<script>
import header from "../components/headers";
import footer from "../components/footer";
export default {
  data() {
    return {
      isactive: 1,
      falg: false
    };
  },
  components: {
    headers: header,
    footers: footer
  }
};
</script>

<style lang="less" scoped>
.course {
  .cuorse_top {
    height: 63px;
    line-height: 63px;
    min-width: 1410px;
    ul {
      li {
        float: left;
        margin: 0 24px;
        a {
          display: block;
          width: 100%;
          height: 100%;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .is-active {
      color: #258ffc;
      font-weight: 800;
    }
  }
}
</style>